import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IStandardTranscriptAPIResponse } from '../../shared/interfaces/standard-transcript.interface';
import { StandardTranscriptNormalizedModel } from '../../shared/models/standard-transcript-normalized.model';
import { IAceTranscriptAPIResponse } from '../../shared/interfaces/ace-transcript.interface';
import { TDataQueryName } from '../configurations/router';

@Injectable({
  providedIn: 'root',
})
export class TranscriptionService {
  constructor(private readonly http: HttpClient) {}

  getStandardTranscription(query: TDataQueryName, id: string): Observable<StandardTranscriptNormalizedModel> {
    return this.http
      .get<IStandardTranscriptAPIResponse>(`standard-transcription/${query}/${id}`)
      .pipe(map((response) => new StandardTranscriptNormalizedModel(response?.retrievedTranscript)));
  }

  getAceTranscription(query: TDataQueryName, id: string): Observable<IAceTranscriptAPIResponse> {
    return this.http.get<IAceTranscriptAPIResponse>(`ace-transcription/${query}/${id}`);
  }

  getAudioRecording(query: TDataQueryName, id: string): Observable<string> {
    return this.http
      .get(`audio/${query}/${id}`, { responseType: 'text' })
      .pipe(map((response) => 'data:audio/ogg;base64,' + response));
  }

  validateId(query: TDataQueryName, id: string): Observable<void> {
    return this.http.get<void>(`check-communication/${query}/${id}`);
  }
}
